// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"347":"d54d20a1","787":"97339a5d","788":"d416602d","812":"3c1e7305"}[chunkId] + ".chunk.js";
};